import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const include = path => () => import(`@/views/${path}`)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'layout',
      component: include('layout'),
      children: [
        {
          path: '/shares/:shareId/:filename?',
          name: 'shares',
          component: include('shares')
        },
        {
          path: '/verification',
          name: 'verification',
          component: include('verification')
        },
        {
          path: '/join-event',
          name: 'joinEvent',
          component: include('join-event')
        }
      ]
    }
  ]
})

export default router
